import { render, staticRenderFns } from "./FiltrosCliente.vue?vue&type=template&id=34ae60e5"
import script from "./FiltrosCliente.vue?vue&type=script&lang=js"
export * from "./FiltrosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports